import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

	@font-face {
		font-family: 'GT America';
		src: url('./fonts/GT-America/gt-america-standard-regular-webfont.woff2') format("woff2"),
		url('./fonts/GT-America/gt-america-standard-regular-webfont.woff') format("woff"), 
		url('./fonts/GT-America/gt-america-standard-regular-webfont.ttf') format("truetype");
		font-display: swap;
	}
	
	#nprogress {
		pointer-events: none;
	}

	#nprogress .bar {
		background: ${({ theme }) => theme.colors.neutral[500]};
		position: fixed;
		z-index: 1031;
		top: 0;
		left: 0;
		width: 100%;
		height: 5px;
	}

	#nprogress .peg {
		display: block;
		position: absolute;
		right: 0px;
		width: 100px;
		height: 100%;
		box-shadow: 0 0 10px red, 0 0 5px red;
		opacity: 1;
		-webkit-transform: rotate(3deg) translate(0px, -4px);
		-ms-transform: rotate(3deg) translate(0px, -4px);
		transform: rotate(3deg) translate(0px, -4px);
	}


  *, ::after, ::before {
    box-sizing: border-box;
	}
	
	:root {
		font-size: 16px;
	}

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    height: 100%;
  }

  body {
    margin: 0;
    background: #fff;
		color: #000;
    height: 100%;
  }

  #__next {
    height: 100%;
  }

  h1, h2, h3, h4, h5, a, p, span {
    font-family: ${({ theme }) =>
      theme.fonts.primary},  -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 400;
    line-height: 1.2;
  }

  img {
    user-select: none;
  }

  button {
    cursor: pointer;

    &:hover {
      outline: none;
    }
  }

  a {
		text-decoration: none;
		color: #000;
		cursor: pointer;
  }

  h2 {
    font-size: calc(24px + (36 - 24) * ((100vw - 300px) / (1600 - 300)));
  }
  h3 {
    font-size: calc(18px + (24 - 18) * ((100vw - 300px) / (1600 - 300)));
  }
  h4 {
    font-size: calc(16px + (18 - 16) * ((100vw - 300px) / (1600 - 300)));
  }
  h5 {
    font-size: calc(14px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
  }
  input {
    border-radius: 0;
  }

  button, input {
    -webkit-appearance: none;
  }

  button:focus {
    outline: none;
  }
`;
